import React from 'react';

interface Props {
  carrierOptions: any;
  selectedCarriers: any;
  setSelectedCarriers: any;
}
function CarrierOptionForm({
  carrierOptions,
  selectedCarriers,
  setSelectedCarriers,
}: Props) {
  const handleCarrierOptionClick = (id: string) => {
    const isCarrierSelected = selectedCarriers.includes(id);
    if (isCarrierSelected) {
      setSelectedCarriers((prevSelected: any) =>
        prevSelected.filter((carrierId: any) => carrierId !== id)
      );
    } else {
      setSelectedCarriers((prevSelected: any) => [...prevSelected, id]);
    }
  };
  return (
    <div className='row mt-5'>
      <div className='col-md-12'>
        <div className='ubbe-new-card bg-white h-100'>
          <div className='card-body p-4'>
            <h5 className='headingGroundCareer'>
              Ground Carrier Options (Not Mandatory)
            </h5>

            <div
              className='row px-4'
              id='carrier_options'
            >
              {carrierOptions &&
                carrierOptions.length > 0 &&
                carrierOptions.map((option: any, index: any) => (
                  <div
                    key={index}
                    className='col-sm-12 col-md-12 col-lg-4 col-xl-3 px-1 py-3'
                  >
                    <div className='option-radio'>
                      <div className='option-radio-success'>
                        <input
                          className='carrier carrier-options-class'
                          type='checkbox'
                          id={option['id']}
                          value={option['id']}
                          name={option['name']}
                          checked={selectedCarriers.includes(option['id'])}
                          onChange={() =>
                            handleCarrierOptionClick(option['id'])
                          }
                        />
                        <label htmlFor={option['id']}>{option['name']}</label>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CarrierOptionForm;
